module.exports = __webpack_public_path__ + "static/img/ptGame6.0f65b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame6.png
// module id = 99Q4
// module chunks = 3